jQuery(function($) {

  
  /* VAR */
  var TabletteWidth = 768;
  var l_window = $(window).width();
  var h_window = $(window).height();
   var topMenuHeight = 75;


    /* Attention // uniquement si mobile ou tablette ! PODOM */
    $('#primary-menu li.menu-item-has-children > a').click(function(e) {
      $(this).parent().toggleClass('focus');
      e.preventDefault();

      // charge transition
  });



      /* ANIMATION BLOCK VISITE EN BAS DES PAGES PARENTES STANDARD */
      /* *****************  */



    if ( $( ".BottomVisiterDomaine" ).length ) { 

      const boxes = gsap.utils.toArray('.BottomVisiterDomaine');
      boxes.forEach(box => {
         var img = box.querySelector('.BottomVisiterDomaine-Img');
          gsap.from(img, {
          y: '40%',
          ease: "none",
          scrollTrigger: {
            trigger:box,
            // start: "top bottom", // the default values
             end: "top center",
           // scrub: true
          }, 
        });

      });

    }



    /* *****************  */
    /* GESTION SLIDER PAGES EVENEMENTS ENFANTS
  /* *****************  */


    $('.SlidePageEvt').slick({
        slidesToShow: 1,
        infinite:false,
        slidesToScroll: 1,
       // adaptiveHeight: true,
        arrows: true,
        dots:false,
        autoplay: true,
        autoplaySpeed: 3000,
       // rows: 1,
       fade: true,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows:true,
              //dots: true,
              infinite:false,
              fade: false,
           //   rows: 1
            }
          }
        ],
          
    });






    /* *****************  */
    /* GESTION SLIDER HOME PAGE : TEXTE LEFT ET IMG RIGHT 
  /* *****************  */


    $('.HomeSlide').slick({
        slidesToShow: 1,
        infinite:false,
        slidesToScroll: 1,
       // adaptiveHeight: true,
        arrows: true,
        dots:true,
        autoplay: true,
        autoplaySpeed: 3000,
        rows: 1,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows:false,
              dots: true,
              rows: 1
            }
          }
        ],
           fade: true,
    });





  /**********************************/
  /******GALERIE ****/
  /**********************************/

  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
   // adaptiveHeight: true,
    arrows: false,
    speed:1200,
    //fade: true,
    asNavFor: '.slider-nav',
      responsive: [
      {
        breakpoint: 1024, // = 1024
        settings: {
          dots: false,
          arrows:false,
        }
      },
    ]
  });

  $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
   // centerMode: true,
    focusOnSelect: true,
      responsive: [
      {
        breakpoint: 1200, // = 1024
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          arrows:false,
           centerMode: false,
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
           centerMode: false,
          arrows:false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });


  /**********************************/
  /****** GALERIE DEPENDANCES ****/
  /**********************************/


  $('.slider-for-dep').each(function(key, item) {

      var sliderIdName = 'slider' + key;
      var sliderNavIdName = 'gallerijnav' + key;

      //this.id = sliderIdName;
      //$('.gallerijnav')[key].id = sliderNavIdName;

      var sliderId = '#' + sliderIdName;
      var sliderNavId = '#' + sliderNavIdName;

    $(sliderId).slick({
      slidesToScroll: 1,
     // adaptiveHeight: true,
      arrows: false,
      speed:1200,

      //fade: true,
       asNavFor: sliderNavId,
        responsive: [
        {
          breakpoint: 1024, // = 1024
          settings: {
            dots: false,
            arrows:false,
          }
        },
    ]
      });

      $(sliderNavId).slick({
        asNavFor: sliderId,
        slidesToShow: 4,
        //slidesPerRow:4,
        slidesToScroll: 1,
        dots: false,
        rows:1,
        //centerMode: true,
        focusOnSelect: true,
          responsive: [
          {
            breakpoint: 1200, // = 1024
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: true,
              arrows:false,
               centerMode: false,
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
               centerMode: false,
              arrows:false
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });


      // var $parent = $(sliderId);
      // var $nav = $(sliderNavId);
      // var $content = $nav.find("div");
      // var killit = false;
      // $content.on("click", function(e){
      // if( !killit ) {
      //   //console.log('here'+idx);
      //     var slide_active = $(this).data("slide-num");
      //    // console.log(slide_active+ "");

      //     e.stopPropagation();
      //    var idx = $(this).data("thumb");
      //     $parent.slick("goTo", idx+1);
      // }
      // });

});


  //  $('.slider-for-dep').slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //  // adaptiveHeight: true,
  //   arrows: false,
  //   speed:1200,

  //   //fade: true,
  //   asNavFor: '.slider-nav-dep',
  //     responsive: [
  //     {
  //       breakpoint: 1024, // = 1024
  //       settings: {
  //         dots: false,
  //         arrows:false,
  //       }
  //     },
  //   ]
  // });

  // $('.slider-nav-dep').slick({
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   asNavFor: '.slider-for-dep',
  //   dots: false,
  //   rows:2,
  //   //centerMode: true,
  //   focusOnSelect: true,
  //     responsive: [
  //     {
  //       breakpoint: 1200, // = 1024
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1,
  //         dots: true,
  //         arrows:false,
  //          centerMode: false,
  //       }
  //     },
  //     {
  //       breakpoint: 500,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //         dots: true,
  //          centerMode: false,
  //         arrows:false
  //       }
  //     }
  //     // You can unslick at a given breakpoint now by adding:
  //     // settings: "unslick"
  //     // instead of a settings object
  //   ]
  // });



  /* *****************  */
    /* GESTION DU LOADER AU CLICK SUR LES LIENS
  /* *****************  */
 

    $("#primary-menu a, a.js-add-loader, #secondary-menu a, #third-menu a").click(function(evt){
       l_window = $(window).width();
       if(l_window > TabletteWidth){
       
        var link = $(this).attr("href");
        var $animated = true;
        
        if($(this).parent().hasClass('notthisanimated') && $('body').hasClass('page-template-m_dependances')){
            $animated = false;
            $( ".menu-toggle" ).trigger( "click" );
            $('body').removeClass('open-menu');
            // on scroll à la bonne section et on referme le menu..
            // on recuperer le dernier troncon de l'url
           // var hash = url.split('#').pop();
           // var hash = $(link).attr('hash');
            var hash = link.split('#').pop();
            if(hash) {
              if($('#'+hash).length){

                var offsetTop = $('#'+hash).offset().top-topMenuHeight+1;
                $('html, body').stop().animate({ 
                    scrollTop: offsetTop
                }, 500);


              }

            }
        } 
        if($animated){
           transition_on();
          setTimeout(function() {
              window.location.href = link;
          }, 400);
        }
        
        evt.preventDefault();

        }
    });




    function transition_on(){
      $('body').addClass('transition_on');
    }  

   
    var header = $('#masthead');
     $( ".menu-toggle" ).click(function() {
    if($(this).attr('aria-expanded') == "true"){
        $('body').addClass('open-menu');
    }else{
       if($('body').hasClass('open-menu')){
        $('body').removeClass('open-menu');
      }
    }
  });
  

  // DECOUPER EN SPAN
  $('.anim_letter').each(function(){
    $(this).html($(this).text().replace(/([^\x00-\x80]|\w)/g, "<span class='letter'>$&</span>"));
  });

  /* *****************  */
    /* ANIMATION DU TITRE // SPECIAL HOME PAGE */

   anime.timeline({loop: false})
        .add({
          targets: '.IntroTop--Home .letter',
          translateX: [50,0],
          scaleX: [-0.5,1],
          translateY: [0,0],
          opacity: [0,1],
          easing: "easeOutExpo",
          duration: 1200,
          delay: function(el, i) {
            return 2600 + 30 * i;
          },
    });

    /* *****************  */
    /* ANIMATION DU TITRE // SPECIAL PAGE PARENTE */


     anime.timeline({loop: false})
        .add({
          targets: '.IntroTop--Page .letter',
          translateX: [30,0],
          scaleX: [-0.5,1],
          translateY: [0,0],
          opacity: [0,1],
          easing: "easeOutExpo",
          duration: 1200,
          delay: function(el, i) {
            return 250 + 30 * i;
          },
    });


/* **************************************************  */
/* GESTION DE LA PAGE "DEPENDANCES*/
/* **************************************************  */

   /* **************************************************  */
  /* ****************** NICEDROPDOWN / DEPENDANCES  */
  /* **************************************************  */
  $('.to_nicedropdown-js').niceSelect();
  $('.js-special_sub_menu_mobile').on('change', function() {
     var href = this.value;
    scroll_to_section(href);
  });

   /* **************************************************  */
  /* ****************** NICEDROPDOWN / ACTUALITES  */
  /* **************************************************  */
  $('.js-special_smenu_actus').on('change', function() {
     var href = this.value;
     window.location.href = href;
  });

  /*************/
      /* SUBMENU SCROLLING = ACTIVE + LINK TO SECTION //*/
      /*************/
    function scroll_to_section(href_dest){
      var variable = 20;
        //  if (href == "#realisations")  variable = 170;
        l_window = $(window).width();
        if(l_window < 1101){
          variable = 95;
        }
      var offsetTop = href_dest === "#" ? 0 : $(href_dest).offset().top-topMenuHeight+1-variable;
      $('html, body').stop().animate({ 
          scrollTop: offsetTop
      }, 500);
    }


/* ********************************************** */
/* **** SUB MENU SUR LA GAUCHE ************* */
/* ********************************************** */

       // Cache selectors
  var lastId,
      topMenu = $("#masthead"),
      $SubMenuLink = $("#sub_menu_aside"),
      // All list menuItems
      menuItems = $SubMenuLink.find("a"),
      // Anchors corresponding to menu items
      scrollItems = menuItems.map(function(){
        var item = $($(this).attr("href"));
        if (item.length) {return item;}
      });
   
 
  // Bind click handler to menu items
  // so we can get a fancy scroll animation
  menuItems.click(function(e){
    var href = $(this).attr("href");
    var variable = 0;
        var offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+1-variable;
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 500);
        
     
      e.preventDefault();
  });

    // Bind to scroll
  $(window).scroll(function(){
     // Get container scroll position
     var fromTop = $(this).scrollTop();
    
     // Get id of current scroll item
     var cur = scrollItems.map(function(){
        variable_top = 10;
       if ($(this).offset().top - topMenuHeight - variable_top < fromTop)
       {

         return this;
       }
     });
     // Get the id of the current element
     cur = cur[cur.length-1];
     var id = cur && cur.length ? cur[0].id : "petites-chambre-double";
      
     if (lastId !== id) {
         lastId = id;
         // Set/remove active class
         menuItems.removeClass("active");
         menuItems.filter("a[href='#"+id+"']").addClass("active");
     }else{
      // console.log('here' + id);
      // menuItems.filter("a[href='#section_1']").addClass("active");
     }                 
  });


  // ** //
  // AU RECHARGEMENT OU AU SCROLL DE LA PAGE = ON FAIT SCROLL SMOOTH VERS LA POSITION // 
  // ** // 
  function scroll_good_anchor(){
     if(window.location.hash) {
      var $hash_location = window.location.hash;
      if($($hash_location).length){
         var offsetTop = $hash_location === "#" ? 0 : $($hash_location).offset().top-topMenuHeight;
          $('html, body').stop().animate({ 
              scrollTop: offsetTop
          }, 500);
      }
    } 
  }

  scroll_good_anchor();


  $('body').removeClass('transition_on');

 


  function cancelClassActive(){

      $( "a.js-action-schema" ).removeClass('active_lb');
      $( "g.g_x5F_hover" ).removeClass('active_lb');
  }

  /**** Schema zone cliquable ***/
  /***************************************/
    $( ".g_x5F_hover" ).click(function() {
      
        var destination_modal = $("#modal-"+$(this).data('info'));

        $( this ).addClass('active_lb');
        $('a.js-action-schema[data-cores="'+$(this).data('info')+'"]').addClass('active_lb');


        if (destination_modal.length ) { 

          $.featherlight(destination_modal, {
              beforeClose: cancelClassActive
          });
        }
    //if()
    //
  });


    // Hover liste lieu sur la gauche
    var corres_schema = '';

    $( "a.js-action-schema" ).hover(
      function() {
        corres_schema = $( this ).data('cores');
        $('.domaine-schema--svg').find('g.'+corres_schema).addClass('active');
      }, function() {
        $('.domaine-schema--svg').find('g.'+corres_schema).removeClass('active');
      }
    );


    // Click sur lieu sur la gauche
    $( "a.js-action-schema" ).click(function(e) {
      
        var destination_modal = $("#modal-"+$(this).data('cores'));
        corres_schema = $( this ).data('cores');

        $( this ).addClass('active_lb');
        $('.domaine-schema--svg').find('g.'+corres_schema).addClass('active_lb');
       
        if (destination_modal.length ) { 

          $.featherlight(destination_modal, {
             beforeClose: cancelClassActive
          });
        }

        e.preventDefault();

  });




       /* *****************  */
    /* ANIMATION DANS LES PAGES PARENTES STANDARD
  /* *****************  */

    if ( $( ".PresPage" ).length ) { 

      const boxes = gsap.utils.toArray('.PresPageItem');
      boxes.forEach(box => {
       
         var img = box.querySelector('.PresPageItem-Img');
          gsap.from(img, {
          y: '40%',
          ease: "none",
          scrollTrigger: {
            trigger:box,
            // start: "top bottom", // the default values
             end: "top center",
            scrub: true
          }, 
        });

          var txt = box.querySelector('.PresPageItem-Desc');
          gsap.from(txt, {
          y: '40px',
          ease: "none",
          scrollTrigger: {
            trigger:box,
            // start: "top bottom", // the default values
             end: "top center",
            scrub: true
          }, 
        });


      });

    }





});




